import { Add, Delete, Edit } from "@mui/icons-material";
import BlindsClosedIcon from "@mui/icons-material/BlindsClosed";
import { RemoveRedEye } from "@mui/icons-material";
import {
  Grid,
  IconButton,
  Skeleton,
  Stack,
  TableCell,
  Tooltip,
  Typography,
} from "@mui/material";
import EmptyContent from "components/EmptyContent";
import List from "components/UI/List";
import { useAlert } from "contexts/alertContext";
import { Feature } from "models/api";
import React, { useEffect, useState } from "react";
import { QueryClient, useMutation } from "react-query";
import Search from "components/Search/Search";
import { handleError } from "helpers/utils";
import useFetchSection from "hooks/useFetchSection";
import DeleteModal from "components/UI/Form/partials/Delete";
import { InputTypes } from "constants/enums";
import { IFormField } from "models/app";
import AddModalReseller from "./partials/Add";
import EditModalReseller from "./partials/Edit";
import { IPolicy, IPolicyInput } from "models/policy";
import { IQuestion, IQuestionInput } from "models/question";
import { addQuestion, deleteQuestion, editQuestion, getQuestions, QuestionCells } from "framework/question";
import Image from "components/UI/Image";

interface Props {
  feature: Feature;
}


const Questions: React.FC<Props> = ({ feature }) => {

  const [loading2, setLoading2] = useState<boolean>(false);
  const [FilterPolicies, setFilterPolicies] = useState<IQuestion[]>([] as IQuestion[]);
  const [openAdd, setOpenAdd] = useState<boolean>(false);
  const [openEdit, setOpenEdit] = useState<boolean>(false);
  const [openDelete, setOpenDelete] = useState<boolean>(false);
  const [SelectedPolicy, setSelectedPolicy] = useState<IQuestion | null>(null);
  const [inputObj, setInputObj] = useState<IQuestionInput>({} as IQuestionInput);
  const { setAlert } = useAlert();

  // eslint-disable-next-line
  const queryClient = new QueryClient();

  const addUserMutation = useMutation({
    mutationFn: (createInput: FormData) => {
      return addQuestion(createInput);
    },
  });

  const editUserMutation = useMutation({
    mutationFn: (data: { createInput: FormData; resellerId: string }) => {
      return editQuestion(data.createInput, data.resellerId);
    },
  });

  const deleteUserMutation = useMutation({
    mutationFn: (id: string) => {
      return deleteQuestion(id);
    },
  });

  const {
    loading,
    data: Policies,
    error,
    revalidate,
  } = useFetchSection({
    fetchData: () => getQuestions(),
    fetchPermission: async () => null,
    section: "Policies",
    onSuccess: (data) => setFilterPolicies(data),
  });


  if (loading)
    return (
      <Stack spacing={2} p={2}>
        {Array.from({ length: 10 }).map((_, i) => (
          <Skeleton variant="rectangular" key={i} width="100%" height={30} />
        ))}
      </Stack>
    );

  const handleChange = (name: string, value: any) => {
    setInputObj((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOpenAdd = () => {
    setOpenAdd(true);
    setInputObj((prev) => ({
      ...prev
    }));
  }

  const handleOpenEdit = (user: IQuestion) => {
    setSelectedPolicy(user);
    setOpenEdit(true);
  };

  const handleOpenDelete = (user: IQuestion) => {
    setSelectedPolicy(user);
    setOpenDelete(true);
  };

  const handleClose = () => {
    setOpenAdd(false)
    setOpenEdit(false);
    setOpenDelete(false);
    setSelectedPolicy(null);
    setInputObj({} as IQuestionInput)
  }

  const getBodyCells = (row: IQuestion) => {
    let cells = Object.keys(row).map((key: string, i: number) => {
      if (key === "questionText")
        return {
          id: "questionText",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row?.questionText}</Typography>
            </TableCell>
          ),
        };

      if (key === "questionDescription")
        return {
          id: "questionDescription",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row?.questionDescription || ""}</Typography>
            </TableCell>
          ),
        };

      if (key === "isActive")
        return {
          id: "isActive",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row?.isActive ? "True" : "False"}</Typography>
            </TableCell>
          ),
        };

      if (key === "questionImagePath")
        return {
          id: "questionImagePath",
          element: (
            <TableCell align={"left"} key={i}>
              <Image url={row?.questionImagePath} alt="image" />
            </TableCell>
          ),
        };

      if (key === "questionID")
        return {
          id: "actions",
          element: (
            <TableCell align={"left"} key={i}>
              <Stack
                direction={"row"}
                alignContent={"center"}
                spacing={1}
              >

                <Tooltip title={"Edit"}>
                  <IconButton
                    size={"small"}
                    color={"primary"}
                    onClick={() => handleOpenEdit(row)}
                  >
                    <Edit />
                  </IconButton>
                </Tooltip>


                <Tooltip title={"Delete"}>
                  <IconButton
                    size={"small"}
                    sx={{
                      color: "red",
                    }}
                    onClick={() => handleOpenDelete(row)}
                  >
                    <Delete />
                  </IconButton>
                </Tooltip>


                {/* <Tooltip title={`Go to ${userId === '1' ? "User" : "Doctor"}`}>
                  <IconButton
                    size={"small"}
                    sx={{
                      color: "#9e9e52",
                    }}
                    onClick={() => navigate(`${row.userId}`)}
                  >
                    <RemoveRedEye />
                  </IconButton>
                </Tooltip> */}

              </Stack>
            </TableCell>
          ),
        };
    });
    return cells;
  };

  const handleAdd = async () => {


    // if (
    //   !isValidNumber(inputObj.countryCode + inputObj.contactNumber))


    //   return setAlert({
    //     open: true,
    //     message: "This Phone is not valid in this country",
    //     type: "error",
    //   });

    try {
      setLoading2(true);

      let formData = new FormData();

      inputObj.questionText && formData.append("questionText", inputObj.questionText);
      formData.append("questionDescription", inputObj.questionDescription || "");
      inputObj.image && formData.append("image", inputObj.image);

      await addUserMutation.mutateAsync(formData);
      setAlert({
        open: true,
        message: `Question added successfully`,
        type: "success",
      });
      revalidate();
      handleClose();
      setInputObj({} as IQuestionInput);
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleEdit = async () => {

    if (inputObj.questionText === null || inputObj.image === null)
      return setAlert({
        open: true,
        message: "Fill all required fields",
        type: "error",
      });

    try {
      setLoading2(true);

      let formData = new FormData();
      inputObj.questionText && formData.append("questionText", inputObj.questionText);
      'questionDescription' in inputObj && formData.append("questionDescription", inputObj?.questionDescription || "-1");
      inputObj.image && inputObj.image && formData.append("image", inputObj.image);


      await editUserMutation.mutateAsync({
        createInput: formData,
        resellerId: SelectedPolicy!?.questionID?.toString()
      });



      setAlert({
        open: true,
        message: `Question updated successfully`,
        type: "success",
      });
      revalidate();
      handleClose();
      setInputObj({} as IQuestionInput);
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleDelete = async () => {
    try {
      setLoading2(true);
      await deleteUserMutation.mutateAsync(SelectedPolicy!.questionID?.toString());
      setAlert({
        open: true,
        message: `Question deleted successfully`,
        type: "success",
      });
      revalidate();
      handleClose();
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleSearch = (value: string) => {
    if (!Policies) return;

    const searchTerm = value.trim().toLowerCase();

    if (!searchTerm) {
      setFilterPolicies(Policies);
      return;
    }

    const filtered = Policies.filter(({ questionText, questionDescription }) => {
      const fullText = `${questionText} ${questionDescription}`.toLowerCase();
      return fullText.includes(searchTerm);
    });

    setFilterPolicies(filtered);
  };


  let addBasicFields: IFormField[] = [
    {
      name: 'questionText',
      label: 'Question Text',
      type: InputTypes.TEXT,
      placeholder: 'Enter Question Text',
      internalLabel: true,
      required: true
    },
    {
      name: 'questionDescription',
      label: 'Question Description',
      type: InputTypes.TEXT,
      placeholder: 'Enter Question Description',
      internalLabel: true,
      required: false
    },
    {
      name: 'image',
      label: 'Image',
      type: InputTypes.FILE,
      placeholder: 'Select Image',
      internalLabel: true,
      required: true
    }
  ];


  let editBasicFields: IFormField[] = [
    {
      name: 'questionText',
      label: 'Question Text',
      type: InputTypes.TEXT,
      placeholder: 'Enter Title',
      defaultValue: SelectedPolicy?.questionText || '',
      internalLabel: true,
      required: true
    },
    {
      name: 'questionDescription',
      label: 'Question Description',
      type: InputTypes.TEXT,
      placeholder: 'Enter Question Description',
      defaultValue: SelectedPolicy?.questionDescription || '',
      internalLabel: true,
      required: false
    },
    {
      name: 'image',
      label: 'Image',
      type: InputTypes.FILE,
      placeholder: 'Select File',
      defaultValue: SelectedPolicy?.questionImagePath || '',
      internalLabel: true,
      required: true
    }
  ];


  return (
    <>
      <Stack spacing={2} p={2}>
        <Grid
          container
          direction={"row"}
          justifyContent={"space-between"}
          alignItems="center"

        >
          <Stack
            direction={"row"}
            spacing={1}
            justifyContent={"space-between"}
            width={"100%"}
            sx={{ mb: 4 }}
          >
            <Typography
              variant="h3"
              color={"header.primary"}
            >
              {(feature.name)}
            </Typography>

            <Tooltip title={"Add"}>
              <IconButton
                sx={{
                  color: "black",
                  height: 40,
                  width: 40,
                  transition: "0.5s",
                }}
                onClick={handleOpenAdd}
              >
                <Add />
              </IconButton>
            </Tooltip>

          </Stack>
          <Stack
            direction={"row"}
            spacing={1}
            justifyContent={"space-between"}
            width={"100%"}
          >
            <Stack
              direction={{ lg: "row", xs: "column" }}
              spacing={1}
              width={"100%"}
            >
              <Search handleChange={handleSearch} placeholder={"Search"} />
            </Stack>
          </Stack>
        </Grid>

        {FilterPolicies.length > 0 && (
          <List
            headCells={QuestionCells}
            data={FilterPolicies}
            getBodyCells={getBodyCells}
            feature={feature}
            canEdit={false}
          />
        )}
        {(!FilterPolicies || FilterPolicies.length === 0) &&

          <EmptyContent
            icon={<BlindsClosedIcon sx={{ fontSize: "3.5rem " }} />}
            header={"No Questions"}
            message={`No Questions Exists Yet`}
          />
        }


      </Stack>

      {openAdd && (
        <AddModalReseller
          open={openAdd}
          loading={loading2}
          disabled={!inputObj.questionText || !inputObj.image}
          title={`Add Question`}
          basicFields={addBasicFields}
          onClose={handleClose}
          onSubmit={handleAdd}
          onChanges={handleChange}
        />
      )}
      {openEdit && (
        <EditModalReseller
          open={openEdit}
          loading={loading2}
          title={`Edit Question`}
          basicFields={editBasicFields}
          onClose={handleClose}
          onSubmit={handleEdit}
          onChanges={handleChange}
        />
      )}
      {openDelete && (
        <DeleteModal
          open={openDelete}
          loading={loading2}
          title={`Delete Question`}
          description={`Are You Sure You Want to delete this Question`}
          onClose={handleClose}
          onSubmit={handleDelete}
        />
      )}
      {/* {openView && (
        <ViewClientsModal
          open={openView}
          title="View Client Subscriptions"
          feature={feature}
          onClose={handleClose}
        />
      )} */}
    </>
  );
};

export default Questions;
